import styled, { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
  html {
    font-size: 100%;
  }
  body {
    color: #000;
    font-family: Segoe UI,Helvetica Neue,Helvetica,Lucida Grande,Arial,Ubuntu,Cantarell,Fira Sans,sans-serif;
    background: #ffffff;
  }
  h1, h2, h3, h4, p {
    margin: 0;
  }

  ul, li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  img {
    display: block;
    max-width: 100%;
  }
  button, input {
    display: block;
    font-size: 1rem;
    font-family: Segoe UI,Helvetica Neue,Helvetica,Lucida Grande,Arial,Ubuntu,Cantarell,Fira Sans,sans-serif;
    color: #000;
  }
  a {
    text-decoration: none;
    color: #000;
  }

  /* ========================================
     ESTILOS GLOBAIS - TOASTS (react-toastify)
     ======================================== */

  /* Container dos toasts */
  .Toastify__toast-container {
    z-index: 99999 !important;
    padding: 16px;
  }

  /* Toast base */
  .Toastify__toast {
    font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    border-radius: 12px !important;
    padding: 16px 20px !important;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08) !important;
    backdrop-filter: blur(10px);
    border: none !important;
    min-height: auto !important;
    margin-bottom: 12px !important;
  }

  /* Toast de sucesso */
  .Toastify__toast--success {
    background: linear-gradient(135deg, #10b981, #34d399) !important;
    color: white !important;
  }

  .Toastify__toast--success .Toastify__toast-icon svg {
    fill: white !important;
  }

  /* Toast de erro */
  .Toastify__toast--error {
    background: linear-gradient(135deg, #ef4444, #f87171) !important;
    color: white !important;
  }

  .Toastify__toast--error .Toastify__toast-icon svg {
    fill: white !important;
  }

  /* Toast de aviso/warning */
  .Toastify__toast--warning {
    background: linear-gradient(135deg, #f59e0b, #fbbf24) !important;
    color: white !important;
  }

  .Toastify__toast--warning .Toastify__toast-icon svg {
    fill: white !important;
  }

  /* Toast de info (padrão azul do sistema) */
  .Toastify__toast--info {
    background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254)) !important;
    color: white !important;
  }

  .Toastify__toast--info .Toastify__toast-icon svg {
    fill: white !important;
  }

  /* Toast padrão/default */
  .Toastify__toast--default {
    background: white !important;
    color: #374151 !important;
    border: 1px solid #e5e7eb !important;
  }

  /* Ícone do toast */
  .Toastify__toast-icon {
    width: 24px !important;
    margin-right: 14px !important;
  }

  /* Corpo do toast */
  .Toastify__toast-body {
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
  }

  /* Botão de fechar */
  .Toastify__close-button {
    color: currentColor;
    opacity: 0.7;
    padding: 0;
    margin-left: 12px;
    align-self: center;
    transition: opacity 0.2s ease;
  }

  .Toastify__close-button:hover {
    opacity: 1;
  }

  .Toastify__close-button > svg {
    width: 16px;
    height: 16px;
  }

  /* Barra de progresso */
  .Toastify__progress-bar {
    height: 3px !important;
    border-radius: 0 0 12px 12px !important;
    background: rgba(255, 255, 255, 0.4) !important;
  }

  .Toastify__progress-bar--success,
  .Toastify__progress-bar--error,
  .Toastify__progress-bar--warning,
  .Toastify__progress-bar--info {
    background: rgba(255, 255, 255, 0.4) !important;
  }

  .Toastify__progress-bar--default {
    background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254)) !important;
  }

  /* Animações customizadas */
  .Toastify__bounce-enter--top-center {
    animation-name: toastSlideDown;
  }

  .Toastify__bounce-exit--top-center {
    animation-name: toastSlideUp;
  }

  @keyframes toastSlideDown {
    from {
      opacity: 0;
      transform: translateY(-100%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes toastSlideUp {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-100%);
    }
  }

  /* Responsividade mobile */
  @media (max-width: 480px) {
    .Toastify__toast-container {
      padding: 8px;
      width: calc(100% - 16px) !important;
      left: 8px !important;
      right: 8px !important;
    }

    .Toastify__toast {
      font-size: 13px;
      padding: 14px 16px;
      border-radius: 10px;
    }
  }

  /* Estilos para impressão - Ocultar elementos que interferem */
  @media print {
    .crisp-client,
    div[class*="crisp"],
    .leftmenu-mobile-status-toggle,
    #crisp-chatbox,
    [class*="crisp"],
    .cc-1brb6,
    .cc-1yy0g,
    .cc-1m2mf {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      z-index: -9999 !important;
      position: absolute !important;
      left: -9999px !important;
      top: -9999px !important;
    }
  }
`;

export const Container = styled.div`
  width: 90%;
  height: calc(100vh - 120px);
  margin: 20px auto;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  position: relative;

  @media (max-width: 1200px) {
    margin: 0 auto;
    height: 100vh;
  }

  &::before {
    content: "";
    background-color: #009688;
    width: 100%;
    height: 15rem;
    position: fixed;
    left: 0;
    top: 56px;
    --z-index: -1;
  }
`;
